module.exports = __webpack_public_path__ + "assets/img/wx_r-50.d96f44e8.png";